import tw, { css, styled } from 'twin.macro'

export const BannerSection = styled.div`
	${tw`bg-cover bg-no-repeat w-full bg-right md:bg-center flex items-center justify-center`}
	height: 500px;
	max-height: 500px;

	@media (min-width: 320px) {
		height: 250px;
		max-height: 250px;
	}

	@media (min-width: 525px) {
		height: 300px;
		max-height: 300px;
	}

	@media (min-width: 768px) {
		height: 300px;
		max-height: 300px;
	}

	@media (min-width: 1024px) {
		height: 400px;
		max-height: 400px;
	}
	@media (min-width: 1280px) {
		height: 500px;
		max-height: 500px;
	}
`
export const Heading1 = tw.h1`text-center text-white font-bold text-2xl md:text-3xl lg:text-4xl tracking-wider font-display`

export const Heading2 = tw.h2`text-xl md:text-2xl lg:text-3xl font-display font-bold mb-8 text-center`
export const SecondSectionText = tw.p`font-display text-center mb-6`
export const SecondSection = tw.div`py-8 md:py-16 flex flex-col items-center justify-center w-full md:w-10/12 lg:w-9/12 xxl:w-8/12 px-4 mx-auto`

export const WhichRobotSection = tw.section`py-8 md:py-16 px-4 bg-gray-200`
export const WhichRobotContainer = tw.div`w-full md:w-10/12 lg:w-9/12 xxl:w-6/12 mx-auto flex flex-col items-center justify-center`
export const WhichRobotParagraph = tw.p`mb-6 font-display text-center`
export const WhichRobotList = tw.ol`flex flex-col justify-center mb-10`
export const WhichRobotListItem = tw.li`mb-2 text-center`
export const WhichRobotButton = tw.button`font-display text-white uppercase text-white text-sm md:text-base py-2 px-6 leading-none border border-yellow-500 bg-yellow-500 hover:border-yellow-400 hover:bg-yellow-400 rounded`

export const RobotsSection = tw.section`py-16`
export const RobotsContainer = tw.div`w-11/12 xxl:w-9/12 mx-auto flex flex-col items-center`
export const RobotHeading = styled(Heading2)``
export const RobotCategory = tw.h3`font-bold text-xl font-display mb-8`
export const RobotClass = tw.h4`font-display text-lg font-semibold mb-4`
export const TableText = tw.p``
export const Tables = tw.div`w-full md:w-10/12 mx-auto`

export const TableComp = styled.table`
	${tw`border-collapse mt-8 mb-16 w-full`}

	thead > tr > th {
		${tw`border border-gray-400 text-center py-3 px-2 font-display`}
	}
	tbody > tr > td {
		min-width: 200px;
		${tw`border border-gray-400 p-4 font-display`}

		> svg {
			${tw`w-36 mx-auto`}
		}

		> ul {
			${tw`list-disc px-4`}

			> li {
				${tw`mb-1`}
			}
		}
	}
	tbody > tr > td.type {
		${tw`w-32`}
	}
	tbody > tr > td.type > a {
		${tw`underline`}

		&:hover {
			${tw`no-underline`}
		}
	}
	tbody > tr > td:not(:last-of-type) {
		${tw`text-center`}
	}
	tbody > tr > td:last-of-type {
		${tw`max-w-md min-w-full`}
	}
`
export const TableButton = styled(WhichRobotButton)`
	${tw`uppercase`}
`

export const BenefitsSection = tw.section`bg-gray-200 py-12`
export const BenefitsContainer = tw.div``
export const BenefitsList = styled.ul`
	${tw`w-9/12 mx-auto flex flex-col md:flex-row mb-8`}
	> li {
		${tw`md:px-4 flex flex-col w-full md:w-4/12 h-full`}
	}
	> li > svg {
		${tw`w-28 md:w-40 h-full mx-auto mb-4`}
	}
	> li > p {
		${tw`text-center font-display mt-auto`}
	}
	> li:not(:last-of-type) {
		${tw`mb-8 md:mb-0`}
	}
`
export const VideoContainer = tw.div`w-full md:w-9/12 mx-auto`
export const Video = styled.iframe`
	@media (max-width: 767px) {
		max-width: 100%;
	}
	max-width: 600px;
	height: 320px;
	${tw`mx-auto`}
`
export const TextContainer = styled.div`
	${tw`w-11/12 md:w-9/12 mx-auto mt-8`}

	> p {
		${tw`mb-6 font-display text-center`}
	}
`
export const AwardSection = tw.section`py-16`
export const AwardContainer = styled.div`
	${tw`w-11/12 md:w-9/12 mx-auto flex flex-col items-center`}

	> h3 {
		${tw`font-display text-lg mb-10`}
	}

	> p {
		${tw`font-display text-center`}

		&:not(:last-of-type) {
			${tw`mb-8`}
		}
	}
`
